module.exports = __webpack_public_path__ + "../resources/images/FocusedInbox-ad9714a8e43d44001c69608f1156d4fc.svg";